import { UploadCoinField } from './UploadCoinField'
import { withUploadCoinField } from './withUploadCoinField'

const ConnectedUploadCoinField = withUploadCoinField(UploadCoinField)

export { ConnectedUploadCoinField as UploadCoinField }
